import script from "./BaseTemplateContentText.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseTemplateContentText.vue?vue&type=script&setup=true&lang=js"

import "./BaseTemplateContentText.vue?vue&type=style&index=0&id=14390dd8&lang=sass&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14390dd8"]])

export default __exports__